/* 🤖 this file was generated by svg-to-ts*/
export const iconDisorderCategoryAdverse: {
  name: 'disorder_category_adverse';
  data: string;
} = {
  name: 'disorder_category_adverse',
  data: `<svg width="32" height="32" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><rect fill="#FFFFF" width="32" height="32" rx="16"/><path d="M10.28 19.5l.5-2H21.22l.5 2H10.28zm2.72-5h1a1 1 0 001-1c0-.579.42-1 1-1 .58 0 1 .421 1 1a1 1 0 001 1c.737 0 1.375.405 1.722 1H12c0-.579.42-1 1-1zm10.97 5.758l-1-4A.999.999 0 0022 15.5h-.142a3.997 3.997 0 00-3.007-2.904A2.951 2.951 0 0016 10.5c-1.33 0-2.432.824-2.835 2H13c-1.682 0-3 1.317-3 3a.999.999 0 00-.97.758l-1 4A.998.998 0 009 21.5h14a.998.998 0 00.97-1.242z" fill="#767676"/></g></svg>`,
};
